
const Loader:React.FC = () => {
  return <div className="flex justify-center m-20">
    <img src="/Rainbow.gif" alt="loading..."/>
  </div>;
};

export {Loader};
